
export default {
  data() {
    return {
      isMounted: false,
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },

        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Slika",
          type: "image",
          size: "80x80",
        },
      ],
    };
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    showGbPart() {
      var show = false;
      if (this.isMounted) {
        if (this.$refs.gbLogo && this.$refs.gbLogo.computedValue) {
          show = true;
        } else show = false;
      }
      return show;
    },
  },
};
